var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9368 7.22925V10.0209",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9368 15.6042V18.3959",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9368 23.9792V26.7709",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9785 7.22925H26.5202C27.2606 7.22925 27.9706 7.52337 28.4942 8.04691C29.0177 8.57045 29.3118 9.28052 29.3118 10.0209V14.2084C28.5714 14.2084 27.8614 14.5025 27.3378 15.0261C26.8143 15.5496 26.5202 16.2597 26.5202 17.0001C26.5202 17.7405 26.8143 18.4505 27.3378 18.9741C27.8614 19.4976 28.5714 19.7917 29.3118 19.7917V23.9792C29.3118 24.7196 29.0177 25.4297 28.4942 25.9533C27.9706 26.4768 27.2606 26.7709 26.5202 26.7709H6.9785C6.2381 26.7709 5.52803 26.4768 5.00449 25.9533C4.48095 25.4297 4.18683 24.7196 4.18683 23.9792V19.7917C4.92722 19.7917 5.6373 19.4976 6.16084 18.9741C6.68437 18.4505 6.9785 17.7405 6.9785 17.0001C6.9785 16.2597 6.68437 15.5496 6.16084 15.0261C5.6373 14.5025 4.92722 14.2084 4.18683 14.2084V10.0209C4.18683 9.28052 4.48095 8.57045 5.00449 8.04691C5.52803 7.52337 6.2381 7.22925 6.9785 7.22925",
    stroke: "#6D6D6D",
    strokeWidth: 2.79167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5,
    height: 33.5,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.af7feffb6118ad14e1a6579e4e9a9dcd.svg";
export { ForwardRef as ReactComponent };